import { SupportRequestStatusEnum } from '@/app/entities/SupportRequest'
import { httpClient } from '../http/httpClient'

interface updateSupportRequestParams {
  number: string
  status?: SupportRequestStatusEnum
  comment?: string
  resolution?: string
  files?: File[]
}
export const updateSupportRequest = async ({
  number,
  status,
  comment,
  resolution,
  files,
}: updateSupportRequestParams) => {
  if (!files?.length) {
    const response = await httpClient.put(`/support-requests/${number}`, {
      status,
      comment,
      resolution,
    })
    return response.data
  }

  const formData = new FormData()
  if (status) formData.append('status', status)
  if (comment?.trim()) formData.append('comment', comment.trim())
  if (resolution) formData.append('resolution', resolution)
  files.forEach((file) => formData.append('files', file))

  const response = await httpClient.put(
    `/support-requests/${number}`,
    formData,
    { headers: { 'Content-Type': 'multipart/form-data' } },
  )
  return response.data
}
